define('models',['require'],function (require) {
    'use strict';
    return {
        provider: new Object({
            Adestinn: 0,
            Hotelbeds: 1
        })
    };
});
 
